/* eslint-disable max-classes-per-file */
import { isPlatformBrowser } from '@angular/common';
import { ClassProvider, FactoryProvider, InjectionToken, PLATFORM_ID, Injectable } from '@angular/core';

/**
 * Injection token for injecting the window into a component
 */
export const WINDOW = new InjectionToken('WindowToken');

/**
 * Abstract window class
 */
export abstract class WindowRef {

    get nativeWindow(): Window | object {
        throw new Error('Not implemented.');
    }

}

/**
 * Implementation for browser window object
 */
@Injectable()
export class BrowserWindow extends WindowRef {

    constructor() {
        super();
    }

    get nativeWindow(): Window | object {
        return window;
    }

}

/**
 * Factory that returns the native window object.
 * @param browserWindowRef browserWindowRef
 * @param platformId platformId
 */
export function windowFactory(browserWindowRef: BrowserWindow, platformId: object): Window | object {

    if (isPlatformBrowser(platformId)) {
        return browserWindowRef.nativeWindow;
    }

    return new Object();
}

/**
 *  Injectable provider for the WindowRef token that uses the BrowserWindow class.
 */
const browserWindowProvider: ClassProvider = {
    provide: WindowRef,
    useClass: BrowserWindow
};

/**
 * Injectable provider that uses the windowFactory function for returning the native window object.
 */
export const windowProvider: FactoryProvider = {
    provide: WINDOW,
    useFactory: windowFactory,
    deps: [WindowRef, PLATFORM_ID]
};


export const WINDOW_PROVIDERS = [
    browserWindowProvider,
    windowProvider
];
